/* eslint camelcase: "off" */
import PropTypes from 'prop-types';

import React from 'react';
import classnames from 'classnames';
import { Type } from '@nerdwallet/currency';

import decode from '~/client/lib/render-utils';

class SearchResultsArticle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { id, data, className, query, position, currentPage } = this.props;
    const { link, title_rendered, content_type, category_names, highlights } =
      data;

    return (
      <div key={id} className={classnames(className, 'search-results-article')}>
        <div className="article-body">
          <Type
            size={1}
            uppercase
            color="neutral-light"
            className="article-type-button"
          >
            {category_names.length > 0 && (
              <span className="article-type-category">{category_names[0]}</span>
            )}
            <span className="article-type-content">{content_type}</span>
          </Type>
          <Type size={3} component="h3" className="article-headline">
            <a
              href={`${link}?trk_location=ssrp&trk_query=${encodeURIComponent(
                query
              )}&trk_page=${currentPage}&trk_position=${position}`}
            >
              {decode(title_rendered)}
            </a>
          </Type>
          {highlights[0]?.trim() ? (
            <Type
              size={2}
              className="article-text"
              dangerouslySetInnerHTML={{
                __html: `&hellip;${highlights[0].trim()}&hellip;`,
              }}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SearchResultsArticle.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  query: PropTypes.string,
  position: PropTypes.number,
  currentPage: PropTypes.number,
};

export default SearchResultsArticle;
